import { render, staticRenderFns } from "./ModalProductSnapshot.vue?vue&type=template&id=9cd870ce&scoped=true&"
import script from "./ModalProductSnapshot.vue?vue&type=script&lang=js&"
export * from "./ModalProductSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductSnapshot.vue?vue&type=style&index=0&id=9cd870ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd870ce",
  null
  
)

export default component.exports